import React from 'react';
import scrollToElement from 'scroll-to-element';
import Button from 'material-ui/Button';
import BuilderIcon from 'material-ui-icons/FormatShapes';
import SupervisorAccountIcon from 'material-ui-icons/SupervisorAccount';
import TimelineIcon from 'material-ui-icons/Timeline';
import InsertDriveFileIcon from 'material-ui-icons/InsertDriveFile';
import WatchLaterIcon from 'material-ui-icons/WatchLater';
import FormatListBulletedIcon from 'material-ui-icons/FormatListBulleted';
import RepeatIcon from 'material-ui-icons/Repeat';

import { Link } from 'react-router-dom';

export default class Home extends React.Component {

	componentDidMount() {
		this.jumpToHash();
	}
	
	componentDidUpdate(prevProps) {
		this.jumpToHash();
	}
	
	jumpToHash = () => {
		const hash = window.location.hash;
		if (hash) {
			scrollToElement(hash, { offset: -120 });
		}
	}

	render(){ 
		return (
			<div style={{ textAlign:'center',  fontFamily:"Open sans"}}>
				<div className="home-top-section" style={{ textAlign:'center', backgroundColor:'rgb(82, 169, 220)', color:'white', padding:'100px 25px'}}>
					<div style={{fontSize:'36px', marginBottom:'20px'}}>
						Psychology testing is easy.<br />
						At least, now it is.
					</div>
					Fast, easy, flexible and reliable testing for psychology research.
					<div style={{marginTop:'40px', marginBottom:'400px'}}>
						<ParticipantButton />
						<span style={{margin:'0 30px'}}> OR </span>
						<ResearcherButton />
					</div>
					
				</div>
				<div style={{ textAlign:'center', backgroundColor:'white', padding:'0px 25px'}}>
					<iframe width="1000px" height="564px" style={{marginTop:'-450px'}} src="https://www.youtube.com/embed/hJDOInnh0Es?rel=0&amp;showinfo=0" frameBorder="0" allow="autoplay; encrypted-media" allowFullScreen></iframe>
					<div style={{padding:'75px'}}>
					<div id="features" style={{fontSize:'145%', marginBottom:'50px'}}>Designed from the ground up for psychology experiments.</div>
						<div style={{display:'flex', flexDirection:'row'}}>
							<BenefitCard
								title="Easily Create Tests"
								icon={BuilderIcon}
								description="Our unique builder makes it simple and intuitive to create custom experiments without programming"
							/>
							<BenefitCard
								icon={SupervisorAccountIcon}
								title="Target Audience"
								description="Optionally set profile attributes particpants must satisfy to be be a part of your experiment"
							/>
							<BenefitCard
								icon={TimelineIcon}
								title="Immediate Results"
								description="View a high-level overview of responses to verify your experiment is working as expected"
							/>
							<BenefitCard
								icon={InsertDriveFileIcon}
								title="Export Data"
								description="All datas are available to export as a CSV for further analysis in SPSS, Excel, or R"
							/>
						</div>
					</div>
					
				</div>
				<div id="how-it-works" style={{ textAlign:'center', backgroundColor:'rgb(245, 245, 245)', color:'var(--gray-text)', padding:'100px 20px'}}>
					<div style={{display:'flex', flexDirection:'row', maxWidth:'900px', margin:'0 auto'}}>
						<div style={{flex:1, padding:'0 15px'}}>
							For Researchers
							<div style={{textAlign:'left', minHeight:'120px'}}>
								<ul>
									<li>Easily distribute experiments to targeted audiences</li>
									<li>Quickly construct experiments</li>
									<li>No programming</li>
								</ul>
							</div>
							<ResearcherButton />
						</div>
						<div style={{flex:1, padding:'0 15px'}}>
							For Participants
							<div style={{textAlign:'left', minHeight:'120px'}}>
								<ul>
									<li>Earn incentives for participating in experiments</li>
									<li>Help support research to solve important issues</li>
								</ul>
							</div>
							<ParticipantButton />
						</div>
					</div>
				</div>
				<div style={{ textAlign:'center', backgroundColor:'#dedede', padding:'100px 20px'}}>
					<div style={{fontSize:'145%', marginBottom:'50px'}}>A Builder To Build It All</div>
					<div style={{display:'flex', flexDirection:'row'}}>
						<BenefitCard
							title="Millisecond Timing"
							icon={WatchLaterIcon}
							description="Millisecond accurate stimulus presentation and response times makes it easy to accurately conduct experiments"
						/>
						<BenefitCard
							icon={TimelineIcon}
							title="Multiple Stimulus Types"
							description="Design with text, images, audio, and video"
						/>
						<BenefitCard
							icon={FormatListBulletedIcon}
							title="Multiple Response Types"
							description="Supports short/long answer, multiple choice, slider, mouse click, Likert scale, and clickable regions"
						/>
						<BenefitCard
							icon={RepeatIcon}
							title="Repeatable Sections"
							description="Easily repeat over groups of slides for a given data set"
						/>
					</div>
				</div>
				<div style={{ textAlign:'center', backgroundColor:'rgb(51, 51, 51)', color:'#cecece', padding:'100px 20px'}}>
					&copy; {(new Date()).getFullYear()} Venkman
					
					<div style={{fontSize:'12px', marginTop:'20px'}}>* Google Chrome is the preferred browser for using Venkman.</div>
				</div>
			</div>
		);
	}
}


function BenefitCard({title, description, icon}){
	const Icon = icon;
	return (
		<div style={{flex:1, padding:'0 15px'}}>
			<Icon style={{height:'100px', width:'100px', color:'var(--green)'}} />
			<div style={{fontSize:'125%', margin:'25px 0 10px 0', color:'var(--gray-text)'}}>{title}</div>
			{description}
		</div>
	);
}

function ParticipantButton(){
	return (
	<Link to="/signup">
		<Button onClick={e => window.app.signupForm.isResearcher = false } variant="raised" color="default" style={{backgroundColor:'#e4ca0f'}}>
			SIGN UP AS A PARTICIPANT
		</Button>
	</Link>
	);
}
function ResearcherButton(){
	return (
	<Link to="/signup">
		<Button onClick={e => window.app.signupForm.isResearcher = true } variant="raised" color="default" style={{backgroundColor:'#e4ca0f'}}>
			SIGN UP AS A RESEARCHER
		</Button>
	</Link>
	);
}


// WEBPACK FOOTER //
// ./src/components/Home.js